module.exports = __webpack_public_path__ + "media/images/language-icon-8bb56c9a497f1a52f2339e291fd7bbb9.png";